import { FluentColorPersonWarning20, ProiconsKey } from '../../../assets/icon/iconify'

interface Props {
    handleChangePassword: () => void;
}

export default function PasswordWarningBanner({ handleChangePassword }: Props) {
    return (
        <div className="flex flex-shrink-0 items-center gap-3 rounded-xl border border-yellow-200 bg-yellow-50 px-3 py-2.5 sm:px-4">
            <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-yellow-100">
                <FluentColorPersonWarning20 height={22} width={22} />
            </div>

            <div className="min-w-0 flex-1">
                <p className="text-[11px] font-semibold leading-tight text-yellow-900 sm:text-xs">
                    Temporary password detected
                </p>

                <p className="mt-0.5 hidden text-[10px] leading-tight text-yellow-700 sm:block">
                    Please change your password to keep your account secure.
                </p>
            </div>

            <button
                type="button"
                onClick={handleChangePassword}
                className="flex flex-shrink-0 items-center justify-center gap-1.5 rounded-lg border border-yellow-200 bg-white px-2.5 py-2 text-[10px] font-semibold text-yellow-800 shadow-sm transition hover:bg-yellow-100 active:scale-[0.98] sm:px-3 sm:text-xs"
            >
                <ProiconsKey height={14} width={14} />
                <span>Change Password</span>
            </button>
        </div>
    )
}
